import {Atom} from '@packages/systems/wfdl';
import {TRecord, TText} from '@packages/systems/wfdl-ast';

/**
 * This atom is only meant to be used as an intermediary in the process of
 * rendering legacy Dynamo rich text values that are represented as HTML strings
 * in the CMS. WFDL Elements representing this atom are only created by the
 * renderer when a Dynamo universal binding to RichText is evaluated and the
 * evaluation process encounters a legacy HTML string value instead of the
 * expected JSON node tree.
 *
 * DO NOT USE OR INSTANTIATE THIS ATOM FOR ANY OTHER PURPOSE.
 */
const config = Atom.create({
  render: Atom.createRender(() => null),
  dataType: TRecord({
    value: TText,
  }),
  showEmpty: false,
});

export default config;
